import { useId, useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { saveLiteratureDraft } from "@/lib/literatureDraft";
import { CORE_FEATURES } from "@/lib/coreFeatures";

export function ResearchLauncher() {
  const [question, setQuestion] = useState("");
  const [storageError, setStorageError] = useState(false);
  const navigate = useNavigate();
  const id = useId();
  function openLiterature(event: FormEvent) {
    event.preventDefault();
    if (!question.trim()) return;
    if (!saveLiteratureDraft(question)) { setStorageError(true); return; }
    navigate("/app/literature");
  }
  return <section className="research-launcher" aria-label="新建研究任务">
    <div className="research-task-body">
      <form onSubmit={openLiterature} className="research-question-form">
        <div className="research-search-heading"><h2>文献检索</h2><span>PubMed / Europe PMC</span></div>
        <label htmlFor={id}>研究，从一个问题开始</label>
        <div className="research-question-row">
          <input id={id} aria-label="研究问题" value={question} onChange={e => setQuestion(e.target.value)} maxLength={4000}
            placeholder="输入研究问题或关键词" required autoComplete="off" />
          <button type="submit" className="btn btn-primary" aria-label="进入文献检索"><span aria-hidden="true">→</span></button>
        </div>
        {storageError && <p role="alert" className="research-helper">浏览器无法保存草稿。请复制问题，<Link to="/app/literature">直接打开检索页</Link>后粘贴。</p>}
      </form>
    </div>
    <div className="research-material-entries">
      {CORE_FEATURES.filter(item => item.key !== "literature").map(item => <Link key={item.key} className="research-material-entry" to={item.to}>
        <div><h2>{item.key === "checkup" ? "论文与图像核查" : "原始数据核查"}</h2>
          <p>{item.key === "checkup" ? "图像完整性 · 统计一致性 · 文本风险" : "重复记录 · 变量关系 · 异常分布"}</p>
          <span className="research-material-format">{item.key === "checkup" ? "PDF / 图片" : "Excel / CSV / TSV"}</span></div>
        <span className="research-entry-arrow" aria-hidden="true">→</span>
      </Link>)}
    </div>
  </section>;
}
